<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/offline/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'tryout/offline/view', params: {id: tryout.id} }">
                                {{ tryout.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Edit Tryout Offline
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <h3>Tryout Offline</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-md-9 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Edit Tryout Offline
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium w-100 text-muted">Jenis TO</label>
                                <h4 class="font-weight-bold">{{ this.tryout.tryoutGroups.length ? 'PTN' : 'UN' }}</h4>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required text-muted">Nama TO</label>
                                <input v-model="form.name" class="form-control form-control-sm" placeholder="Judul" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required w-100 text-muted">Kelas</label>
                                <div class="form-check pl-0" v-for="(grade, index) in grades" v-bind:key="grade.id">
                                    <div class="custom-control custom-checkbox">
                                        <input v-model="form.gradeIDs" type="checkbox" class="custom-control-input" v-bind:value="grade.id" v-bind:id="'input-class-' + grade.id" />
                                        <label class="custom-control-label" v-bind:for="'input-class-' + grade.id">{{ grade.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <template v-if="tryout.tryoutGroups.length">
                                <div class="row">
                                    <div class="col-12">
                                        <template v-for="(tryoutGroup, groupIndex) in form.groups">
                                            <div class="row">
                                                <div class="col-5">
                                                    <label class="font-weight-medium required text-muted">Jenis Kemampuan</label>
                                                </div>
                                                <div class="col-3">
                                                    <label class="font-weight-medium required text-muted">Kode</label>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-5">
                                                    <div class="form-group mb-1">
                                                        <select v-model="tryoutGroup.groupSubjectID" class="form-control form-control-sm" required>
                                                            <option disabled value="">Jenis Kemampuan</option>
                                                            <option v-for="groupSubject in groupSubjects" v-bind:key="groupSubject.id" v-bind:value="groupSubject.id">{{ groupSubject.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-3">
                                                    <div class="form-group mb-1">
                                                        <input v-model="tryoutGroup.code" class="form-control form-control-sm" placeholder="Kode" required />
                                                    </div>
                                                </div>
                                                <div class="col-auto pl-3 text-center">
                                                    <a href="#" v-if="form.groups.length > 1" v-on:click.prevent="removeGroup(groupIndex)">
                                                        <i class="fa fa-times text-danger"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5">
                                                    <label class="font-weight-medium required text-muted">Mata Pelajaran</label>
                                                </div>
                                                <div class="col-3">
                                                    <label class="font-weight-medium required text-muted">Kode</label>
                                                </div>
                                                <div class="col-4">
                                                    <label class="font-weight-medium required text-muted">Jumlah Soal</label>
                                                </div>
                                            </div>
                                            <div class="row" v-for="(tryoutGroupSubject, index) in tryoutGroup.subjects">
                                                <div class="col-5">
                                                    <div class="form-group mb-1">
                                                        <select v-model="tryoutGroupSubject.subjectID" class="form-control form-control-sm" required>
                                                            <option disabled value="">Mata Pelajaran</option>
                                                            <option v-for="subject in subjects" v-bind:key="subject.id" v-bind:value="subject.id">{{ subject.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-3">
                                                    <div class="form-group mb-1">
                                                        <input v-model="tryoutGroupSubject.code" class="form-control form-control-sm" placeholder="Kode" required />
                                                    </div>
                                                </div>
                                                <div class="col-3">
                                                    <div class="form-group mb-1">
                                                        <input v-model="tryoutGroupSubject.totalQuestion" type="number" class="form-control form-control-sm" placeholder="Jumlah Soal" required />
                                                    </div>
                                                </div>
                                                <div class="col-auto pl-1 text-center">
                                                    <a href="#" v-if="form.groups[groupIndex].subjects.length > 1" v-on:click.prevent="removeGroupSubject(groupIndex, index)">
                                                        <i class="fa fa-times text-danger"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <button class="btn btn-link btn-sm px-0" type="button" v-on:click="addGroupSubject(groupIndex)">
                                                        Tambah Mata Pelajaran +
                                                    </button>
                                                </div>
                                            </div>
                                            <hr />
                                        </template>
                                        <div class="row">
                                            <div class="col-12 mb-4 text-right">
                                                <button class="btn btn-link btn-sm px-0" type="button" v-on:click="addGroup()">
                                                    Tambah Jenis Kemampuan +
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-5">
                                                <label class="font-weight-medium required text-muted">Mata Pelajaran</label>
                                            </div>
                                            <div class="col-3">
                                                <label class="font-weight-medium required text-muted">Kode</label>
                                            </div>
                                            <div class="col-4">
                                                <label class="font-weight-medium required text-muted">Jumlah Soal</label>
                                            </div>
                                        </div>
                                        <div class="row" v-for="(tryoutSubject, index) in form.subjects">
                                            <div class="col-5">
                                                <div class="form-group mb-1">
                                                    <select v-model="tryoutSubject.subjectID" class="form-control form-control-sm" required>
                                                        <option disabled value="">Mata Pelajaran</option>
                                                        <option v-for="subject in subjects" v-bind:key="subject.id" v-bind:value="subject.id">{{ subject.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="form-group mb-1">
                                                    <input v-model="tryoutSubject.code" class="form-control form-control-sm" placeholder="Kode" required />
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="form-group mb-1">
                                                    <input v-model="tryoutSubject.totalQuestion" type="number" class="form-control form-control-sm" placeholder="Jumlah Soal" required />
                                                </div>
                                            </div>
                                            <div class="col-auto pl-1 text-center">
                                                <a href="#" v-if="form.subjects.length > 1" v-on:click.prevent="removeSubject(index)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-4">
                                        <button class="btn btn-link btn-sm px-0" type="button" v-on:click="addSubject()">
                                            Tambah Mata Pelajaran +
                                        </button>
                                    </div>
                                </div>
                            </template>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'tryout/offline/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "TryoutOfflineAdd",
        data() {
            return {
                form: {
                    name: '',
                    gradeIDs: [],
                    subjects: [],
                    groups: []
                },
                grades: [],
                subjects: [],
                groupSubjects: [],
                tryout: {tryoutGroups: []}
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/tryout/update/' + this.tryout.id, this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'tryout/offline/view', params: {id: response.data.data.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            addSubject() {
                this.form.subjects.push({
                    id: '',
                    subjectID: '',
                    code: '',
                    totalQuestion: ''
                });
            },
            addGroup() {
                var total = this.form.groups.push({
                    id: '',
                    groupSubjectID: '',
                    code: '',
                    subjects: []
                });
                this.addGroupSubject(total - 1);
            },
            addGroupSubject(groupIndex) {
                this.form.groups[groupIndex].subjects.push({
                    id: '',
                    subjectID: '',
                    code: '',
                    totalQuestion: ''
                });
            },
            removeSubject(index) {
                this.form.subjects.splice(index, 1);
            },
            removeGroup(index) {
                this.form.groups.splice(index, 1);
            },
            removeGroupSubject(groupIndex, index) {
                this.form.groups[groupIndex].subjects.splice(index, 1);
            }
        },
        created() {
            this.addSubject();
            this.axios.all([
                this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/grade'),
                this.axios.get(process.env.API_URL + '/subject'),
                this.axios.get(process.env.API_URL + '/group-subject')
            ]).then(this.axios.spread(function (responseTryout, responseGrade, responseSubject, responseGroupSubject) {
                this.tryout = responseTryout.data.data;
                this.grades = responseGrade.data.data;
                this.subjects = responseSubject.data.data;
                this.groupSubjects = responseGroupSubject.data.data;
                if (this.tryout.tryoutOnline) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Tryout offline not found'}});
                }

                var appends = {};
                if (this.tryout.tryoutGroups.length) {
                    appends = {
                        groups: this.tryout.tryoutGroups.map(tryoutGroup => {
                            return {
                                id: tryoutGroup.id,
                                groupSubjectID: tryoutGroup.groupSubjectID,
                                code: tryoutGroup.code,
                                subjects: tryoutGroup.tryoutSubjects.map(tryoutSubject => {
                                    return {id: tryoutSubject.id, subjectID: tryoutSubject.subjectID, code: tryoutSubject.code, totalQuestion: tryoutSubject.totalQuestion};
                                })
                            };
                        })
                    };
                } else {
                    appends = {
                        subjects: this.tryout.tryoutSubjects.map(tryoutSubject => {
                            return {id: tryoutSubject.id, subjectID: tryoutSubject.subjectID, code: tryoutSubject.code, totalQuestion: tryoutSubject.totalQuestion};
                        })
                    };
                }
                this.form = Object.assign({}, this.tryout, {gradeIDs: this.tryout.grades.map(grade => grade.id)}, appends);
            }.bind(this))).catch((error) => {
                this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
            });

            document.title = 'Edit Tryout Offline - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/tryout/offline/Edit.vue